import { render, staticRenderFns } from "./OperaMenuWindow.vue?vue&type=template&id=2a5e0313&scoped=true&"
import script from "./OperaMenuWindow.vue?vue&type=script&lang=js&"
export * from "./OperaMenuWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaMenuWindow.vue?vue&type=style&index=0&id=2a5e0313&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5e0313",
  null
  
)

export default component.exports